import axios from "axios";
import { UIactions } from "../../../../../store/slices/UI";
import { warehouseActions } from "../../../../../store/slices/warehouse";
import { workerActions } from "../../../../../store/slices/workers";

export const tunnelTokenId = "tunnelToken";
export const rootsDataId = "roots";

const clonerHandlers = {
  startSession: ":5107/startSession",
  getStatus: ":5107/status",
  getRoots: ":5107/roots",
};

const cloner365Handlers = {
  startSession: ":5111/remote/startSession",
  getStatus: ":5111/remote/status",
  getRoots: ":5111/remote/roots",
};

const getMachineStatus = ({
  user,
  mid,
  M365server,
  server,
  cloner_key,
  is365device,
}) => {
  let handlers;
  if (is365device) {
    handlers = cloner365Handlers;
  } else {
    handlers = clonerHandlers;
  }

  return async (dispatch) => {
    dispatch(workerActions.start(tunnelTokenId));
    try {
      let url;
      let url2;
      let url3;
      if (is365device) {
        const base = M365server.split(":");
        url = base[0] + ":" + base[1] + handlers.startSession;
        url2 = base[0] + ":" + base[1] + handlers.getStatus;
        url3 = base[0] + ":" + base[1] + handlers.getRoots;
      } else {
        url = server.slice(0, -1) + handlers.startSession;
        url2 = server.slice(0, -1) + handlers.getStatus;
        url3 = server.slice(0, -1) + handlers.getRoots;
      }
      console.log("Starting session with url:", url);

      let formData = new FormData();
      formData.append("user", user);
      formData.append("machine", mid);
      const response = await axios.post(url, formData, {
        headers: { "Content-Type": "multipart/form-data", cloner_key },
      });
      dispatch(
        UIactions.setValue({ id: tunnelTokenId, value: response.data.token })
      );

      const tunnel_token = response.data.token;
      const response2 = await axios.get(url2, { headers: { tunnel_token } });
      const response3 = await axios.get(url3, { headers: { tunnel_token } });

      const repos = response2.data.repos;
      const roots = response3.data.roots;
      const ids = response3.data.ids;
      const sizes = response3.data.space_sizes;

      // console.log("sizes: ", sizes);

      // console.log("repos: ", repos);
      // console.log("roots: ", roots);
      // console.log("ids: ", ids);

      let newRoots = [];
      let i = 0;
      for (const root of roots) {
        const found = repos.find((x) => x.name === root);
        // const size = sizes.find((s) => s.root === root);
        let newRoot;
        if (is365device) {
          console.log("c365 device")
          const size = sizes.find((s) => s.id === ids[i]);
          // console.log("size", size)
          newRoot = { c365ID: ids[i], id: null, root, size: size.space_used };
        } else {
          console.log("not c365 device")
          newRoot = { id: null, root };
        }

        if (found) {
          // console.log("found a ",root)
          newRoot.id = found.id;
        } else {
          // console.log("not found a ",root)
        }
        newRoots.push(newRoot);
        i++
      }
      dispatch(warehouseActions.load({ id: rootsDataId, data: newRoots }));
    } catch (e) {
      console.error(e);
      dispatch(workerActions.finish({ id: tunnelTokenId, error: e.message }));
    }
    dispatch(workerActions.finish({ id: tunnelTokenId }));
  };
};

export default getMachineStatus;
